module.exports = __webpack_public_path__ + "img/l-hd.a574974f.jpg";